const API_BASE_URL = process.env.REACT_APP_BACKEND_API || 'http://127.0.0.1:8000';

export const API_URLS = {
    // data sources
    DATA_SOURCES: `${API_BASE_URL}/api/source`,

    // threads
    THREADS: `${API_BASE_URL}/api/thread`,

    // users
    USERS: `${API_BASE_URL}/api/user`,

    // bookmarks
    BOOKMARKS: `${API_BASE_URL}/api/bookmark`,

    // feedback
    FEEDBACK: `${API_BASE_URL}/api/feedback`,

    // kpi reporting
    KPI_REPORTING: `${API_BASE_URL}/api/kpi`,

    // emerging alerts
    EMERGING_ALERTS: `${API_BASE_URL}/api/alert`
}